<template>
  <div id="marketViewDetail" class="market-view">
    <div class="progress-line-container">
      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="getLoadingDetail"
      ></v-progress-linear>
    </div>
    <transition-group name="card-in-out">
      <template v-if="!checkIsMobile() && !checkIsTablet()">
        <v-card
          class="event-card-detail"
          v-for="(object, index) in getEventsDetail"
          :key="object.event.source"
        >
          <event-breadcrumb
            :object="object"
            :sport-path="sportPath"
            :category-path="categoryPath"
            :breadcrumb-prematch-type="breadcrumbPrematchType"
            :light="light"
            @remove-detail="removeDetail"
          />

          <EventCardIntroBanner
            :live="false"
            :object="object"
          ></EventCardIntroBanner>

          <v-row
            v-if="
              (object.event.type == 'match' &&
                new Date(object.event.scheduled).getTime() >
                  new Date().getTime()) ||
              object.event.type == 'antepost'
            "
            class="no-padding no-margin"
            style="min-height: 900px"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="px-0"
              v-if="object.event.type == 'match'"
            >
              <!--              todo verify  css TABSV2-->
              <v-tabs
                v-model="tab"
                grow
                class="tabs-list"
                :class="getUseMarketOddsGroupV2 === 'scrollable-1' ? 'v2' : ''"
                show-arrows
              >
                <!--              <v-tab class="group-tab" v-for="group in object.groupMarkets" :key="group.id"-->
                <!--                     @click="getOddsGroup(object.event.id, group.group_id,object.sport.id,(object.tournament.id)?object.tournament.id:'')">-->
                <!--                {{ group.name }}-->
                <!--              </v-tab>-->
                <v-tab
                  class="group-tab"
                  v-for="group in getMarketsGroupsDetailPrematch"
                  :key="
                    'groupTabEventDetail-' + object.event.id + '-' + group._id
                  "
                  @click="
                    getOddsGroup(
                      object.event.id,
                      group._id,
                      object.sport.id,
                      object.tournament.id ? object.tournament.id : ''
                    )
                  "
                >
                  {{
                    group.languages.length > 0 && group.languages[0].text
                      ? group.languages[0].text
                      : group.name != null && group.name != ''
                      ? group.name
                      : 'MarketGroup'
                  }}
                  <!--                  {{group._id}}-->
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab" touchless>
                <v-tab-item
                  v-for="group in getMarketsGroupsDetailPrematch"
                  :key="
                    'detailTabItem-' +
                    object.event.id +
                    '-' +
                    group._id +
                    '-' +
                    group.name
                  "
                >
                  <v-card color="basil" flat v-if="!tab_loading">
                    <masonry
                      :cols="1"
                      :gutter="20"
                      v-if="checkExists(object.event.odds)"
                    >
                      <v-expansion-panels
                        focusable
                        v-model="expansionPanelMarkets"
                        multiple
                      >
                        <template
                          v-if="getGroupedMarkets(object.event.odds).length > 0"
                        >
                          <v-expansion-panel
                            v-if="marketGroup != null && marketGroup[0] != null"
                            v-for="(marketGroup, index) in getGroupedMarkets(
                              object.event.odds
                            )"
                            :key="
                              'detailExpansionPanel-' +
                              object.event.id +
                              '-' +
                              marketGroup[0].id_market +
                              index
                            "
                          >
                            <v-expansion-panel-header>
                              {{ marketGroup[0].name_market }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <div
                                  v-for="(market, index) in marketGroup"
                                  :key="market.unique_id"
                                >
                                  <!--                                                      <div class="market-header">-->
                                  <!--                                                          {{ market.name_market }} {{ (market.specifiers != "") ? market.specifiers : '' }}-->
                                  <!--                                                      </div>-->
                                  <div
                                    class="extended-odds-container col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                    :class="index % 2 == 0 ? 'even' : 'odd'"
                                  >
                                    <div class="col-md-3">
                                      <div
                                        class="market-header"
                                        style="
                                          font-size: 9pt !important;
                                          font-weight: 700 !important;
                                          padding-right: 0.5rem !important;
                                        "
                                      >
                                        {{
                                          market.specifiers != ''
                                            ? market.name_market
                                            : ''
                                        }}
                                        {{
                                          market.specifiers != ''
                                            ? market.specifiers
                                            : ''
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="col-md-9"
                                      style="    display: flex;
    float: right;
    flex-direction: row;
    justify-content: flex-end;
}"
                                    >
                                      <div
                                        class="row"
                                        style="height: auto !important;    height: auto !important;
    display: flex;
    float: right;
    flex-direction: row;
    justify-content: flex-end;
    padding: 4px;
}"
                                      >
                                        <div
                                          v-for="(odd, index) in market.odds"
                                          :key="odd.unique_id"
                                          v-if="
                                            (odd.active ||
                                              (market.showLocked &&
                                                !odd.active)) &&
                                            !odd.unique_id.includes('undefined')
                                          "
                                          @click="
                                            putCart(
                                              odd,
                                              object.event,
                                              object.sport,
                                              object.category,
                                              object.tournament
                                            )
                                          "
                                          :class="[
                                            'extended',
                                            'no-padding',
                                            getSizeOddButtonForMarket(
                                              odd.id_market
                                            ),
                                          ]"
                                        >
                                          <div
                                            :class="[
                                              'value',
                                              'extended-odd',
                                              'multi-' +
                                                market.multiplicity_min,
                                              'equal',
                                              getOddsSources.includes(
                                                odd.unique_id
                                              )
                                                ? 'odd_selected'
                                                : '',
                                            ]"
                                            v-if="
                                              odd.outcome_odd_value > 1.0 &&
                                              odd.active
                                            "
                                          >
                                            <!--                                                                  <div :class="['sign',(getOddsSources.includes(odd.unique_id)) ? 'odd_selected' : '']" >-->
                                            <!--                                                                      {{ odd.outcome_name




                                                                                         }} {{getSpecifiers(odd.market_unique_id)}}-->
                                            <!--                                                                  </div>-->
                                            <!--                                                              <div v-if="odd.outcome_odd_value > 1.00 && odd.active"-->
                                            <!--                                                                   :class="[-->
                                            <!--                                                                       'value',-->
                                            <!--                                                                       'multi-'+market.multiplicity_min,-->
                                            <!--                                                                        (odd.type_change != undefined) ? odd.type_change : 'equal',-->
                                            <!--                                                                        (getOddsSources.includes(odd.unique_id)) ? 'odd_selected' : ''-->
                                            <!--                                                                        ]">-->
                                            <!--                                                                  <v-icon class="arrow-up" v-if="odd.type_change == 'up'">mdi-arrow-up</v-icon>-->
                                            <!--                                                                  <v-icon class="arrow-down" v-if="odd.type_change == 'down'">mdi-arrow-down</v-icon>-->
                                            <!--                                                                  {{ odd.outcome_odd_value | odds_type_filter }}-->
                                            <!--                                                              </div>-->

                                            <div class="extended_sign_value">
                                              <!--                                            {{ odd.outcome_name }} {{odd.specifier}}-->
                                              {{ odd.outcome_name }}
                                            </div>
                                            <div class="extended_odd_value">
                                              <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                                              {{
                                                odd.outcome_odd_value
                                                  | odds_type_filter
                                              }}
                                            </div>

                                            <!--                                                                  <div v-else class="value" :class="'multi-'+market.multiplicity_min">-->
                                            <!--                                                                      <v-icon dense>mdi-lock</v-icon>-->
                                            <!--                                                                  </div>-->
                                          </div>
                                          <div
                                            v-else
                                            :class="[
                                              'value',
                                              'extended-view-locked multi-' +
                                                market.multiplicity_min,
                                            ]"
                                          >
                                            <div class="extended_sign_value">
                                              {{ odd.outcome_name }}
                                            </div>
                                            <div class="extended_odd_value">
                                              <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                                              <v-icon dense>mdi-lock </v-icon>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                      </v-expansion-panels>
                    </masonry>
                    <div v-else>
                      <h3 class="no-odds-message">
                        <v-icon large>mdi-trophy-variant-outline</v-icon>
                        <br />{{ $t('noOddsForThisGroup') }}
                      </h3>
                    </div>
                  </v-card>
                  <v-card v-else>
                    <v-skeleton-loader
                      v-bind="attrs"
                      type="date-picker"
                    ></v-skeleton-loader>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
            <v-col cols="12" v-else-if="object.event.type == 'antepost'">
              <v-card color="basil" flat v-if="!tab_loading">
                <masonry :cols="1" :gutter="20">
                  <div
                    v-for="(market, index) in object.event.odds"
                    :key="market.unique_id"
                    v-if="
                      market.showMarket &&
                      market.odds.length > 0 &&
                      isActiveMarket(market.odds)
                    "
                  >
                    <div class="market-box">
                      <div class="market-header">
                        {{ market.name_market }}
                        {{ market.specifiers != '' ? market.specifiers : '' }}
                      </div>
                      <div class="market-content row">
                        <div
                          v-for="(odd, index) in market.odds"
                          :key="odd.unique_id"
                          v-if="
                            (odd.active ||
                              (market.showLocked && !odd.active)) &&
                            !odd.unique_id.includes('undefined')
                          "
                          @click="
                            putCart(
                              odd,
                              object.event,
                              object.sport,
                              object.category,
                              object.tournament
                            )
                          "
                          class="col-4"
                        >
                          <div class="odd-button">
                            <div
                              :class="[
                                'sign',
                                getOddsSources.includes(odd.unique_id)
                                  ? 'odd_selected'
                                  : '',
                              ]"
                            >
                              {{ odd.outcome_name }}
                              {{ getSpecifiers(odd.market_unique_id) }}
                            </div>
                            <div
                              v-if="odd.outcome_odd_value > 1.0 && odd.active"
                              :class="[
                                'value',
                                'multi-' + market.multiplicity_min,
                                odd.type_change != undefined
                                  ? odd.type_change
                                  : 'equal',
                                getOddsSources.includes(odd.unique_id)
                                  ? 'odd_selected'
                                  : '',
                              ]"
                            >
                              <v-icon
                                class="arrow-up"
                                v-if="odd.type_change == 'up'"
                              >
                                mdi-arrow-up
                              </v-icon>
                              <v-icon
                                class="arrow-down"
                                v-if="odd.type_change == 'down'"
                              >
                                mdi-arrow-down
                              </v-icon>
                              {{ odd.outcome_odd_value | odds_type_filter }}
                            </div>
                            <div
                              v-else
                              class="value"
                              :class="'multi-' + market.multiplicity_min"
                            >
                              <v-icon dense>mdi-lock</v-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </masonry>
              </v-card>
              <v-card v-else>
                <v-skeleton-loader
                  v-bind="attrs"
                  type="date-picker"
                ></v-skeleton-loader>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template
        v-else-if="checkIsMobile() || checkIsTablet()"
        v-show="getMobileCartOpen === false"
      >
        <v-card
          class="event-card-detail detail-mobile"
          elevation="1"
          v-for="(object, index) in getEventsDetail"
          :key="'antepost-mobile-' + object.source + index"
        >
          <template v-show="!getMobileCartOpen && !getProgramOpen">
            <event-breadcrumb
              :object="object"
              :sport-path="sportPath"
              :category-path="categoryPath"
              :breadcrumb-prematch-type="breadcrumbPrematchType"
              :light="light"
              @remove-detail="removeDetail"
            />
            <EventCardIntroBanner
              :mobile="true"
              :object="object"
            ></EventCardIntroBanner>
            <v-row class="no-padding no-margin">
              <v-col
                cols="12"
                v-if="object.event.type == 'match'"
                style="padding: 0px"
              >
                <v-col
                  cols="12"
                  id="container_group_markets_event_detail_odds_mobile"
                >
                  <v-btn-toggle v-model="marketGroupSelected">
                    <v-col
                      class="marketGroupContainer"
                      cols="4"
                      v-for="group in getMarketsGroupsDetailPrematch"
                      :key="group._id + '-' + group.name"
                    >
                      <!--                                            <v-btn small tile class="marketGroup"-->
                      <!--                                                   depressed-->
                      <!--                                                   block-->
                      <!--                                                   @click="getOddsGroup(object.event.id, group._id,object.sport.id,(object.tournament.id)?object.tournament.id:'')">-->
                      <!--                                                <span class="text-sport text-capitalize"> {{ group.name }}</span>-->
                      <!--                                            </v-btn>-->
                      <v-btn
                        small
                        tile
                        class="marketGroup"
                        depressed
                        block
                        @click="
                          getOddsGroup(
                            object.event.id,
                            group._id,
                            object.sport.id,
                            object.tournament.id ? object.tournament.id : ''
                          )
                        "
                      >
                        <span class="text-sport text-capitalize">
                          {{
                            group.languages.length > 0 &&
                            group.languages[0].text
                              ? group.languages[0].text
                              : group.name != null && group.name != ''
                              ? group.name
                              : 'MarketGroup'
                          }}</span
                        >
                      </v-btn>
                    </v-col>
                  </v-btn-toggle>
                </v-col>

                <div
                  v-if="
                    new Date(object.event.scheduled).getTime() >
                    new Date().getTime()
                  "
                >
                  <v-card
                    color="basil"
                    flat
                    v-if="!tab_loading"
                    class="group-odds-mobile"
                    style="border: none"
                  >
                    <masonry :cols="1">
                      <v-expansion-panels
                        focusable
                        v-model="expansionPanelMarkets"
                        multiple
                      >
                        <template
                          v-if="getGroupedMarkets(object.event.odds).length > 0"
                        >
                          <v-expansion-panel
                            v-for="(marketGroup, index) in getGroupedMarkets(
                              object.event.odds
                            )"
                            :key="index"
                          >
                            <v-expansion-panel-header
                              ><span style="padding-left: 6px">{{
                                marketGroup != null
                                  ? marketGroup[0].name_market
                                  : ''
                              }}</span>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <!-- old view market view detail -->
                              <!--                                                <div >-->
                              <!--                                                    <div class="market-box"-->
                              <!--                                                         v-for="(market, index) in marketGroup "-->
                              <!--                                                         :key="market.unique_id">-->
                              <!--                                                        <div v-if="market.specifiers != ''" class="market-header">-->
                              <!--                                                            {{ market.name_market }} {{market.specifiers }}-->
                              <!--                                                        </div>-->
                              <!--                                                        <div class="market-content">-->
                              <!--                                                            <div v-for="(odd, index) in market.odds"-->
                              <!--                                                                 :key="odd.unique_id"-->
                              <!--                                                                 v-if="(odd.active || (market.showLocked && !odd.active)) && !odd.unique_id.includes('undefined')"-->
                              <!--                                                                 @click="putCart(odd, object.event, object.sport, object.category, object.tournament)">-->
                              <!--                                                                <div class="odd-button">-->
                              <!--                                                                    <div :class="['sign',(getOddsSources.includes(odd.unique_id)) ? 'odd_selected' : '']">-->
                              <!--                                                                        {{ odd.outcome_name }}-->
                              <!--                                                                        {{getSpecifiers(odd.market_unique_id)}}-->
                              <!--                                                                    </div>-->
                              <!--                                                                    <div v-if="odd.outcome_odd_value > 1.00 && odd.active"-->
                              <!--                                                                         :class="[-->
                              <!--                                                                       'value',-->
                              <!--                                                                        (odd.type_change != undefined) ? odd.type_change : 'equal',-->
                              <!--                                                                        (getOddsSources.includes(odd.unique_id)) ? 'odd_selected' : ''-->
                              <!--                                                                   ]"-->
                              <!--                                                                    >-->
                              <!--                                                                        <v-icon class="arrow-up"-->
                              <!--                                                                                v-if="odd.type_change == 'up'">-->
                              <!--                                                                            mdi-arrow-up-->
                              <!--                                                                        </v-icon>-->
                              <!--                                                                        <v-icon class="arrow-down"-->
                              <!--                                                                                v-if="odd.type_change == 'down'">-->
                              <!--                                                                            mdi-arrow-down-->
                              <!--                                                                        </v-icon>-->
                              <!--                                                                        {{ odd.outcome_odd_value |-->
                              <!--                                                                        odds_type_filter }}-->
                              <!--                                                                    </div>-->
                              <!--                                                                    <div v-else class="value">-->
                              <!--                                                                        <v-icon dense>mdi-lock</v-icon>-->
                              <!--                                                                    </div>-->
                              <!--                                                                </div>-->
                              <!--                                                            </div>-->
                              <!--                                                        </div>-->
                              <!--                                                    </div>-->
                              <!--                                                </div>-->

                              <div
                                class="market-box"
                                v-for="(market, index) in marketGroup"
                                :key="market.unique_id"
                              >
                                <div
                                  v-if="market.specifiers != ''"
                                  class="market-header"
                                >
                                  {{ market.name_market }}
                                  {{ market.specifiers }}
                                </div>
                                <div class="market-content-odds-list">
                                  <div
                                    v-for="(odd, index) in market.odds"
                                    class="odd"
                                    :key="odd.unique_id"
                                    v-if="
                                      (odd.active ||
                                        (market.showLocked && !odd.active)) &&
                                      !odd.unique_id.includes('undefined')
                                    "
                                    @click="
                                      putCart(
                                        odd,
                                        object.event,
                                        object.sport,
                                        object.category,
                                        object.tournament
                                      )
                                    "
                                    :class="[
                                      getOddsSources.includes(odd.unique_id)
                                        ? 'odd_selected'
                                        : '',
                                    ]"
                                  >
                                    <v-col cols="12" class="odd-outcome-name">
                                      {{ odd.outcome_name }}
                                      {{ getSpecifiers(odd.market_unique_id) }}
                                    </v-col>
                                    <v-col
                                      v-if="
                                        odd.outcome_odd_value > 1.0 &&
                                        odd.active
                                      "
                                      cols="12"
                                      class="odd-outcome-value"
                                    >
                                      {{
                                        odd.outcome_odd_value | odds_type_filter
                                      }}
                                    </v-col>
                                    <div v-else class="locked">
                                      <v-icon dense>mdi-lock</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                      </v-expansion-panels>
                    </masonry>
                  </v-card>
                  <v-card v-else>
                    <v-skeleton-loader
                      v-bind="attrs"
                      type="date-picker"
                    ></v-skeleton-loader>
                  </v-card>
                </div>
              </v-col>
              <v-col cols="12" v-else-if="object.event.type == 'antepost'">
                <v-card
                  color="basil"
                  flat
                  v-if="!tab_loading"
                  class="group-odds-mobile antepost-mobile"
                >
                  <masonry :cols="1" :gutter="20">
                    <div
                      v-for="(market, index) in object.event.odds"
                      :key="
                        'antepost-mobile' +
                        object.source +
                        '-' +
                        market.unique_id +
                        index
                      "
                    >
                      <template
                        v-if="
                          market.showMarket &&
                          market.odds.length > 0 &&
                          isActiveMarket(market.odds)
                        "
                      >
                        <div class="market-box">
                          <div class="market-header">
                            {{ market.name_market }}
                            {{
                              market.specifiers != '' ? market.specifiers : ''
                            }}
                          </div>
                          <div class="market-content row pb-2 pt-2">
                            <div
                              v-for="(odd, index) in market.odds"
                              :key="odd.unique_id"
                              v-if="
                                (odd.active ||
                                  (market.showLocked && !odd.active)) &&
                                !odd.unique_id.includes('undefined')
                              "
                              @click="
                                putCart(
                                  odd,
                                  object.event,
                                  object.sport,
                                  object.category,
                                  object.tournament
                                )
                              "
                              class="col-12 pb-0 pt-0"
                            >
                              <div class="odd-button">
                                <div
                                  :class="[
                                    'sign',
                                    getOddsSources.includes(odd.unique_id)
                                      ? 'odd_selected'
                                      : '',
                                  ]"
                                >
                                  {{ odd.outcome_name }}
                                  {{ getSpecifiers(odd.market_unique_id) }}
                                </div>
                                <div
                                  v-if="
                                    odd.outcome_odd_value > 1.0 && odd.active
                                  "
                                  :class="[
                                    'value',
                                    'multi-' + market.multiplicity_min,
                                    odd.type_change != undefined
                                      ? odd.type_change
                                      : 'equal',
                                    getOddsSources.includes(odd.unique_id)
                                      ? 'odd_selected'
                                      : '',
                                  ]"
                                >
                                  <v-icon
                                    class="arrow-up"
                                    v-if="odd.type_change == 'up'"
                                  >
                                    mdi-arrow-up
                                  </v-icon>
                                  <v-icon
                                    class="arrow-down"
                                    v-if="odd.type_change == 'down'"
                                  >
                                    mdi-arrow-down
                                  </v-icon>
                                  {{ odd.outcome_odd_value | odds_type_filter }}
                                </div>
                                <div
                                  v-else
                                  class="value"
                                  :class="'multi-' + market.multiplicity_min"
                                >
                                  <v-icon dense>mdi-lock</v-icon>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </masonry>
                </v-card>
                <v-card v-else>
                  <v-skeleton-loader
                    v-bind="attrs"
                    type="date-picker"
                  ></v-skeleton-loader>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../../plugins/device-inspector'
import EventCardIntroBanner from '@/components/center_widgets/EventCardIntroBanner.vue'
// import _ from "lodash";

const EventBreadcrumb = () => ({
  component: import('@/components/center_widgets/Previews/EventBreadcrumb'),
})

export default {
  name: 'MarketViewDetail',
  components: {
    EventBreadcrumb,
    EventCardIntroBanner,
  },
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    groupSelected: null,
    tab: null,
    tab_loading: false,
    loading: false,
    antepostType: ['stage', 'season', 'simple_tournament'],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT+'/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    flagTeamsPath: process.env.VUE_APP_URL_FLAG_TEAMS_CLOUDFRONT + '/medium/',
    // sportBackgroundPath: process.env.VUE_APP_URL_SIRPLAY_CLOUDFRONT + '/platform/elements/background/',
    sportBackgroundPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg/',
    expansionPanelMarkets: [],
    marketGroupSelected: 0,
    sportId: window.sportId != null ? window.sportId : null,
    tournamentId: window.tournamentId != null ? window.tournamentId : null,
    eventId: window.eventId != null ? window.eventId : null,
    eventName: window.eventName != null ? window.eventName : null,
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getEventsDetail: 'odds/getEventsDetail',
      getLoadingDetail: 'odds/getLoadingDetail',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getMarketsGroupsDetailPrematch: 'odds/getMarketsGroupsDetailPrematch',
      getMarketsGroupsIdActive: 'odds/getMarketsGroupsIdActive',
      getMarketsMapSizeButtonsDetailPrematch:
        'marketview/getMarketsMapSizeButtonsDetailPrematch',
      getMobileCartOpen: 'cart/getMobileCartOpen',
      getProgramOpen: 'settings/getProgramOpen',
      getMarketOrderForEventDetail: 'marketview/getMarketOrderForEventDetail',
      getMobileMarketOrderForEventDetail:
        'marketview/getMobileMarketOrderForEventDetail',
      getTournamentsActive: 'odds/getTournamentsActive',
      getUseMarketOddsGroupV2: 'uiConfig/marketsGroupLayout',
      breadcrumbPrematchType: 'uiConfig/breadcrumbPrematchType',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromDetail: 'odds/removeFromDetail',
      removeFromDetailV2: 'odds/removeFromDetailV2',
      fetchEventDetailV2: 'odds/fetchEventDetailV2',
      fetchOddsGroupDetailV2: 'odds/fetchOddsGroupDetailV2',
      setLoadingDetail: 'odds/setLoadingDetail',
      addOddToCart: 'cart/addOddToCart',
      updateMarketsMapSizeButtonsDetailPrematch:
        'marketview/updateMarketsMapSizeButtonsDetailPrematch',
    }),
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    removeDetailOrOpenTree(sourceEvent, type, sport, tournament) {
      if (type === 'antepost') {
        this.openLateralMenu()
      } else {
        this.removeDetail(sourceEvent, type, sport, tournament)
      }
    },

    removeDetail(sourceEvent, type, sport, tournament) {
      const tournamentId = tournament.id

      const isPresentTournament = this.getTournamentsActive.find(
        tournamentActive => {
          return tournamentActive === tournamentId + '#prematch'
        }
      )

      if (!isPresentTournament && type != 'antepost') {
        this.openTournamentPreview(
          sport.id,
          sport.name,
          tournament.id,
          tournament.tournamentName
        )
      }

      this.tab = 0

      if (type === 'antepost') {
        this.removeFromDetailV2({ source: sourceEvent, type: type })
      } else {
        this.removeFromDetail({ source: sourceEvent, type: type })
      }

      window.parent.postMessage(
        {
          type: 'removeSlugs',
        },
        '*'
      )

      if (localStorage.getItem('visited-tournament-preview')) {
        const now = new Date().getTime()

        const previewTournamentVisited = localStorage.getItem(
          'visited-tournament-preview'
        )
        let previewTournamentVisitedArray = JSON.parse(previewTournamentVisited)

        previewTournamentVisitedArray = previewTournamentVisitedArray.filter(
          el => {
            return el.expiryTimeJson > now
          }
        )

        const tournament =
          previewTournamentVisitedArray.length > 0
            ? previewTournamentVisitedArray[
                previewTournamentVisitedArray.length - 1
              ]
            : null

        if (tournament != null && type != 'antepost') {
          window.parent.postMessage(
            {
              type: 'tournamentOpened',
              sportId: tournament.sportId,
              tournamentId: tournament.tournamentId,
              sportName: tournament.sportName,
              tournamentName: tournament.tournamentName,
            },
            '*'
          )
        }
      }

      localStorage.removeItem('event-detail')

      this.$store.commit('odds/SET_MARKETS_GROUPS_DETAIL_PREMATCH', [])
      this.marketGroupSelected = 0
      this.expansionPanelMarkets = []
      this.updateMarketsMapSizeButtonsDetailPrematch([])
      this.groupSelected = null
    },

    async getOddsGroup(eventSource, groupId, sport, tournament) {
      if (groupId != this.groupSelected) {
        this.groupSelected = groupId
        this.tab_loading = true
        await this.setLoadingDetail({ status: true })

        await this.fetchOddsGroupDetailV2({
          source: eventSource,
          group: groupId,
          sport: sport,
          tournament: tournament,
          tab: this.tab,
        })

        // todo put me in a function please !!!
        const detailsEvent = this.getEventsDetail
        this.expansionPanelMarkets = []

        const refactored = _.groupBy(detailsEvent[0].event.odds, 'id_market')
        let indexMarket = 0

        for (const [key, value] of Object.entries(refactored)) {
          if (indexMarket < 10) {
            // todo  dont use magic number and for mobile use a number < 10
            this.expansionPanelMarkets.push(indexMarket)
            indexMarket++
          }
        }

        // todo end put me in a function

        await this.setLoadingDetail({ status: false })
        this.tab_loading = false
      }
    },

    async putCart(odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },

    getSpecifiers(spec) {
      let result = ''

      if (!spec) {
        return result
      }

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    isActiveMarket(odds) {
      const check = _.find(odds, { active: true })
      if (check) {
        return true
      } else {
        return false
      }
    },
    checkExists(odds) {
      const check = _.find(odds, { showMarket: true })
      return !!check
    },
    checkHugeMarket(odds) {
      return _.size(odds) > 10 ? true : false
    },
    checkLocked(market) {
      const check = _.find(market.odds, { active: true })
      return !(market.odds.length > 8 && !check)
    },

    getGroupedMarkets(marketOdds) {
      const refactored = _.groupBy(marketOdds, 'id_market')
      const refactoredOrdered = []

      if (this.checkIsMobile() || this.checkIsTablet()) {
        for (const el of this.getMobileMarketOrderForEventDetail) {
          refactoredOrdered.push(refactored[el.marketId])
        }
      } else {
        for (const el of this.getMarketOrderForEventDetail) {
          refactoredOrdered.push(refactored[el.marketId])
        }
      }

      return refactoredOrdered
    },
    getSizeOddButtonForMarket(marketId) {
      let sizeButtons = 'col-md-2 col-lg-2 col-xl-2'
      const marketSizeButtons = this.getMarketsMapSizeButtonsDetailPrematch
      const marketIndex = marketSizeButtons.findIndex(marketButtonInfo => {
        return marketButtonInfo.marketId === marketId
      })
      if (marketIndex != -1) {
        sizeButtons =
          'col-' +
          marketSizeButtons[marketIndex].sizeOddButtonMd +
          ' ' +
          'col-' +
          marketSizeButtons[marketIndex].sizeOddButtonLg +
          ' ' +
          'col-' +
          marketSizeButtons[marketIndex].sizeOddButtonXl
      }

      return sizeButtons
    },
    openFirstExpansionPanelMarkets() {
      const NUMBER_OF_PANELS_TO_OPEN = 10
      this.expansionPanelMarkets = []

      for (let i = 0; i < NUMBER_OF_PANELS_TO_OPEN; i++) {
        this.expansionPanelMarkets.push(i)
      }
    },
    openLateralMenu() {
      this.$root.$emit('open_sidebar_left')
    },

    async openEvent() {
      if (this.eventId) {
        await this.fetchEventDetailV2({
          source: +this.eventId,
          group: null,
          sport: +this.sportId,
          tournament: +this.tournamentId,
          tab: 0,
          eventName: this.eventName,
        })
      }
    },

    openTournamentPreview(sportId, sportName, tournamentId, tournamentName) {
      this.$root.$emit('openTournamentMarketViewPreview', {
        sportId: sportId,
        sportName: sportName,
        tournamentId: tournamentId,
        tournamentName: tournamentName,
      })
    },
  },
  watch: {
    // groupSelected(newValue, oldValue) {
    //     // console.log('[WATCH] groupSelected is changed');
    // },
    getMarketsGroupsDetailPrematch(newValue, oldValue) {
      this.openFirstExpansionPanelMarkets()
      this.tab = 0
    },
    getEventsDetail(newValue, oldValue) {
      if (newValue != null && newValue.length > 0) {
        const eventId = newValue[0].event.id
        if (eventId != null) {
          this.groupSelected = null
          this.marketGroupSelected = 0
        }
      }
    },
  },
  async mounted() {
    console.log('market view detail time: 12.31')
    await this.openEvent()
    this.openFirstExpansionPanelMarkets()
  },
  beforeDestroy() {
    // todo need split the component DETAIL !!! else this component will never splitted
    const empty = []
    this.updateMarketsMapSizeButtonsDetailPrematch(empty)
  },
}
</script>

<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

.bet-console-prefix .event-card-detail .event-card-header .tournament-text {
  font-size: 12px !important;
}
</style>
